<div class="page-wrapper">
  <div class="page-inner">
    @if (!insideIframe && !isLogin && !isDeeplink) {
      <smart-sidebar
        class="d-flex flex-column flex-fill"
      ></smart-sidebar>
    }

    <div class="page-content-wrapper" [ngStyle]="{ 'margin-top.rem': insideIframe ? 1 : isDeeplink ? 6 : 9 }">
      @if (!insideIframe) {
        <smart-page-header [isLogin]="isLogin" [isDeeplink]="isDeeplink"></smart-page-header>
      }

      <main id="js-page-content" role="main" class="page-content">
        @if (!isLogin && !insideIframe) {
          <breadcrumb></breadcrumb>
        }
        <router-outlet></router-outlet>
      </main>
    </div>

    <!-- this overlay is activated only when mobile menu is triggered -->
    @if (!isLogin) {
      <div
        class="page-content-overlay"
        (click)="closeMobileNav($event)"
        data-class="mobile-nav-on"
      ></div>
    }
  </div>
</div>
